import * as api from '../api/revisionHistory';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const REVISION_HISTORY_SEARCH = createRequestTypes(
  'APPRAISAL/REVISION_HISTORY_SEARCH',
);

export const searchRevisionHistory = makeApiActionCreatorV3(
  api.searchRevisionHistory,
  REVISION_HISTORY_SEARCH[START],
  REVISION_HISTORY_SEARCH[SUCCESS],
  REVISION_HISTORY_SEARCH[ERROR],
);

export const REVISION_HISTORY_SEARCH_INTERNAL = createRequestTypes(
  'APPRAISAL/REVISION_HISTORY_SEARCH_INTERNAL',
);

export const searchRevisionHistoryInternal = makeApiActionCreatorV3(
  api.searchRevisionHistoryInternal,
  REVISION_HISTORY_SEARCH_INTERNAL[START],
  REVISION_HISTORY_SEARCH_INTERNAL[SUCCESS],
  REVISION_HISTORY_SEARCH_INTERNAL[ERROR],
);
